// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3dak8","content":"Consent_content__2X7zc","footer":"Consent_footer__20XuW"};